
function Loading()
{
    return(
        <div className="overflow-y-hidden  overflow-x-hidden  " style={{/* backgroundColor:'#e8e8e8', */marginTop:'25rem',marginLeft:'50rem'}}>
            <div  className="loader"></div>
        </div>
    );
}
export default Loading